/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ExportInventoriesParams,
  GetInventoriesParams,
  HTTPValidationError,
  Inventory,
  InventoryCreate,
  InventoryRead,
  InventoryUpdate,
  PageInventoryWithIncomingQuantity,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Create a new inventory record from an existing product.
 * @summary Create Inventory
 */
export const createInventory = (
  inventoryCreate: InventoryCreate,
  signal?: AbortSignal,
) => {
  return customInstance<Inventory>({
    url: `/api/inventory/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: inventoryCreate,
    signal,
  });
};

export const getCreateInventoryMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInventory>>,
    TError,
    { data: InventoryCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInventory>>,
  TError,
  { data: InventoryCreate },
  TContext
> => {
  const mutationKey = ["createInventory"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInventory>>,
    { data: InventoryCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createInventory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInventoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInventory>>
>;
export type CreateInventoryMutationBody = InventoryCreate;
export type CreateInventoryMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Inventory
 */
export const useCreateInventory = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInventory>>,
      TError,
      { data: InventoryCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createInventory>>,
  TError,
  { data: InventoryCreate },
  TContext
> => {
  const mutationOptions = getCreateInventoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many inventory items.

Results are paginated.
 * @summary Get Inventories
 */
export const getInventories = (
  params?: GetInventoriesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageInventoryWithIncomingQuantity>({
    url: `/api/inventory/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetInventoriesQueryKey = (params?: GetInventoriesParams) => {
  return ["api", "inventory", ...(params ? [params] : [])] as const;
};

export const getGetInventoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventories>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInventoriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventories>>> = ({
    signal,
  }) => getInventories(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInventoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventories>>
>;
export type GetInventoriesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetInventories<
  TData = Awaited<ReturnType<typeof getInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetInventoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventories>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventories>>,
          TError,
          Awaited<ReturnType<typeof getInventories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInventories<
  TData = Awaited<ReturnType<typeof getInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventories>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventories>>,
          TError,
          Awaited<ReturnType<typeof getInventories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInventories<
  TData = Awaited<ReturnType<typeof getInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventories>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Inventories
 */

export function useGetInventories<
  TData = Awaited<ReturnType<typeof getInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventories>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInventoriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export inventory items to CSV with true streaming.
Uses the same filters as the base GET endpoint.
 * @summary Export Inventories
 */
export const exportInventories = (
  params?: ExportInventoriesParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/inventory/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportInventoriesQueryKey = (
  params?: ExportInventoriesParams,
) => {
  return ["api", "inventory", "export", ...(params ? [params] : [])] as const;
};

export const getExportInventoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof exportInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportInventories>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportInventoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportInventories>>
  > = ({ signal }) => exportInventories(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportInventories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportInventoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportInventories>>
>;
export type ExportInventoriesQueryError = ErrorType<void | HTTPValidationError>;

export function useExportInventories<
  TData = Awaited<ReturnType<typeof exportInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | ExportInventoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportInventories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportInventories>>,
          TError,
          Awaited<ReturnType<typeof exportInventories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportInventories<
  TData = Awaited<ReturnType<typeof exportInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportInventories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportInventories>>,
          TError,
          Awaited<ReturnType<typeof exportInventories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportInventories<
  TData = Awaited<ReturnType<typeof exportInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportInventories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Inventories
 */

export function useExportInventories<
  TData = Awaited<ReturnType<typeof exportInventories>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportInventoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportInventories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportInventoriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an inventory by ID.
 * @summary Get Inventory
 */
export const getInventory = (inventoryId: string, signal?: AbortSignal) => {
  return customInstance<InventoryRead>({
    url: `/api/inventory/${inventoryId}`,
    method: "GET",
    signal,
  });
};

export const getGetInventoryQueryKey = (inventoryId?: string) => {
  return ["api", "inventory", inventoryId] as const;
};

export const getGetInventoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getInventory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  inventoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInventoryQueryKey(inventoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventory>>> = ({
    signal,
  }) => getInventory(inventoryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!inventoryId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInventory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInventoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInventory>>
>;
export type GetInventoryQueryError = ErrorType<void | HTTPValidationError>;

export function useGetInventory<
  TData = Awaited<ReturnType<typeof getInventory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  inventoryId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventory>>,
          TError,
          Awaited<ReturnType<typeof getInventory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInventory<
  TData = Awaited<ReturnType<typeof getInventory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  inventoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventory>>,
          TError,
          Awaited<ReturnType<typeof getInventory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInventory<
  TData = Awaited<ReturnType<typeof getInventory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  inventoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Inventory
 */

export function useGetInventory<
  TData = Awaited<ReturnType<typeof getInventory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  inventoryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInventory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInventoryQueryOptions(inventoryId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update inventory settings (reorder level).
 * @summary Update Inventory
 */
export const updateInventory = (
  inventoryId: string,
  inventoryUpdate: InventoryUpdate,
) => {
  return customInstance<void>({
    url: `/api/inventory/${inventoryId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: inventoryUpdate,
  });
};

export const getUpdateInventoryMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInventory>>,
    TError,
    { inventoryId: string; data: InventoryUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInventory>>,
  TError,
  { inventoryId: string; data: InventoryUpdate },
  TContext
> => {
  const mutationKey = ["updateInventory"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInventory>>,
    { inventoryId: string; data: InventoryUpdate }
  > = (props) => {
    const { inventoryId, data } = props ?? {};

    return updateInventory(inventoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInventoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInventory>>
>;
export type UpdateInventoryMutationBody = InventoryUpdate;
export type UpdateInventoryMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Inventory
 */
export const useUpdateInventory = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateInventory>>,
      TError,
      { inventoryId: string; data: InventoryUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateInventory>>,
  TError,
  { inventoryId: string; data: InventoryUpdate },
  TContext
> => {
  const mutationOptions = getUpdateInventoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
